export const twoDecimals = (value) => {
  if (value === null || value === undefined) return 0;
  if (value === "empty") return value;
  if (value.toString().slice(-1) === ".") return value;
  return Number.isInteger(Number(value)) || !value
    ? value
    : Number(value).toFixed(2);
};
